module.exports = __webpack_public_path__ + "static/media/img-block-1.de3e2fbe.png";